import React, { useMemo, useState } from 'react';
import { X } from 'lucide-react';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { PageHeader, Reveal } from '../components/site/Kit';

function GalleryPage() {
  const { config: c } = useSiteConfig();
  const [filter, setFilter] = useState('Todo');
  const [open, setOpen] = useState(null);
  const items = useMemo(() => c?.gallery_items || [], [c]);
  const categories = useMemo(() => ['Todo', ...new Set(items.map((i) => i.category).filter(Boolean))], [items]);
  const visible = filter === 'Todo' ? items : items.filter((i) => i.category === filter);

  if (!c) return <div className="min-h-screen" />;

  return (
    <div className="min-h-screen px-4 sm:px-6 lg:px-8 pt-16 pb-24" data-testid="gallery-page">
      <div className="max-w-6xl mx-auto">
        <PageHeader label={c.gallery_label} title={c.gallery_title} text={c.gallery_text} testId="gallery-page-title" />
        <div className="flex flex-wrap gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${filter === cat ? 'bg-[#111] text-white' : 'bg-white text-[#5f6672] hover:text-[#111]'}`}
              data-testid={`gallery-filter-${cat.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {cat}
            </button>
          ))}
        </div>
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [&>*]:mb-4">
          {visible.map((it, i) => (
            <Reveal key={`${it.image}-${i}`} delay={(i % 6) * 0.05}>
              <button onClick={() => setOpen(it)} className="relative block w-full overflow-hidden rounded-xl group text-left" data-testid={`gallery-item-${i}`}>
                <img src={it.image} alt={it.title} className="w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                {(it.title || it.subtitle) && (
                  <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/70 to-transparent text-white">
                    <p className="font-display font-semibold">{it.title}</p>
                    <p className="text-xs text-white/75">{it.subtitle}</p>
                  </div>
                )}
              </button>
            </Reveal>
          ))}
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 z-[60] bg-black/85 flex items-center justify-center p-6" onClick={() => setOpen(null)} data-testid="gallery-lightbox">
          <button className="absolute top-6 right-6 text-white" data-testid="gallery-lightbox-close"><X className="w-7 h-7" /></button>
          <figure className="max-w-5xl" onClick={(e) => e.stopPropagation()}>
            <img src={open.image} alt={open.title} className="max-h-[80vh] w-auto rounded-xl" />
            <figcaption className="text-white mt-4 font-display font-semibold">{open.title} <span className="text-white/60 font-normal text-sm ml-2">{open.subtitle}</span></figcaption>
          </figure>
        </div>
      )}
    </div>
  );
}

export default GalleryPage;
